angular.module('jv.common.ga.service.js', [])
.service('GAService', ['$window', function($window) {
	var GAService = {};
	GAService.track = function(eventName) {
		if(angular.isDefined($window.ga)){
			var gaAction; 
			if(angular.isDefined($window.JV) && angular.isDefined($window.JV.PAGE_TYPE)){
				gaAction = $window.JV.PAGE_TYPE;
			} else {
				gaAction = $window.document.title;
			}
			if (angular.isDefined($window._jvselfUser)) {
				ga('send', 'event', gaAction, eventName, $window._jvselfUser.companyEId);
			} else {
				ga('send', 'event', gaAction, eventName);
			}
		}
	};

	return GAService;
}]);
